define.alias("shared/components/shared/youtube-tos-modal", "settings/components/shared/youtube-tos-modal");